import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema } from "./ApiClient";
import { AtvMessageFormData } from "@/formTypes/AtvMessageFormDataType";

export type AtvMessageDataType = Partial<ApiSchema["AtvMessage"]["type"] & AtvMessageFormData>;
export const AtvMessageApi = new GenericModelApi<"AtvMessage", AtvMessageDataType>("AtvMessage", "sequence", "DESC", "sequence");